module.exports = __webpack_public_path__ + "img/TheMembers-4-es.5ced225c.png";